import { useState } from "react";
import ProfileImgSample from "../../assets/defaults/Profile-Sample0.jpg"

const ProfileSample = ({ id, imgSrc, imgAlt, imgCat, description }) => {
    const [enlarged, setEnlarged] = useState(false);

    const handleImageClick = () => setEnlarged(true);
    const handleClose = () => setEnlarged(false);

    return (
        <>
            <div className="admin-profile-img col-6 col-md-4 p-1 position-relative">
                <p className="position-absolute bottom-0 start-50 mb-4 p-1 translate-middle-x bg-white w-75 text-center rounded">{imgCat}</p>
                <img
                    crossOrigin="anonymous"
                    src={imgSrc ? imgSrc : ProfileImgSample}
                    alt={imgAlt}
                    className="rounded-4 w-100 border"
                    style={{ cursor: "pointer" }}
                    onClick={handleImageClick}
                />
            </div>
            {enlarged && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        background: "rgba(0,0,0,0.7)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 9999,
                    }}
                    onClick={handleClose}
                >
                    <img
                        crossOrigin="anonymous"
                        src={imgSrc ? imgSrc : ProfileImgSample}
                        alt={imgAlt}
                        style={{
                            maxWidth: "90vw",
                            maxHeight: "90vh",
                            borderRadius: "16px",
                            boxShadow: "0 4px 32px rgba(0,0,0,0.5)",
                        }}
                        onClick={e => e.stopPropagation()}
                    />
                </div>
            )}
        </>
    );
};
export default ProfileSample;